"use client";

import { Button, Subtitle2, Text, Title3 } from "@fluentui/react-components";
import { useTranslations } from "next-intl";
import Link from "next/link";

export default function NotFound() {
  const t = useTranslations();
  return (
    <div className="flex items-center justify-center w-full min-h-screen">
      <section className="bg-neutral-background-1">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div className="flex flex-col items-center justify-center gap-4 mx-auto max-w-screen-sm text-center">
            <Text className="text-primary-500" size={1000} weight="bold">
              404
            </Text>
            <Title3 className="text-neutral-foreground-1">{t("error.page.not_found.title")}</Title3>
            <Subtitle2 className="text-neutral-foreground-3">
              {t("error.page.not_found.msg")}
            </Subtitle2>
            <Link href="/">
              <Button appearance="primary" size="large">
                {t("common.btn.back_to_home")}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
